module.exports = __webpack_public_path__ + "static/media/S4N3-5.ba8c5beb.svg";